import { render, staticRenderFns } from "./MedhotRowsDataTable.vue?vue&type=template&id=020c82a1&"
import script from "./MedhotRowsDataTable.vue?vue&type=script&lang=ts&"
export * from "./MedhotRowsDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports